export {default as Registration} from "./_web/Registration";

export {default as reducer }  from './reducer';
